import { getCountryCallingCode, type CountryCode } from "libphonenumber-js";

/**
 * Returns an E.164 dial-code prefix for the market (e.g. "+46").
 */
export default function getMarketDialCode(marketCode: string): string {
  try {
    const callingCode = getCountryCallingCode(
      marketCode.toUpperCase() as CountryCode,
    );
    return `+${callingCode}`;
  } catch {
    return "+";
  }
}
